<svelte:body on:item={put_item}/>
<script>
    import _ from 'lodash';
    import {validate_int} from '../../../validators.js';
    import {parameter, network} from '../../../stores.js';
    import {createEventDispatcher} from 'svelte';
    import {encode, decode} from "../../../helpers";
    import {TabContent, TabPane} from "sveltestrap";

    const dispatch = createEventDispatcher();
    const fixprecision = (value) => Math.ceil(value * 100) / 100;

    export let calc;
    export let options;

    export let put_item = async (e) => {
        let item = e.detail;

        if (item) {
            let fetched = await network.fetch_tovar(item.idTovar)
            let json = JSON.parse(decode(fetched.ind3))

            fetchData = await fetch(json.ind1);

            dlina = json.dlina;
            width = json.width;
            tolsh = json.tolsh;
            upakovka = json.upakovka;
            transupakovka = json.transupakovka;
            kolvoUpak = json.kolvoUpak;
            stiker = json.stiker;
            ind1 = json.ind1;
            ind1Naim = json.ind1Naim;
            vListeShtuk = json.vListeShtuk;
            configuration = json.configuration;
            sloyev = +json.sloyev;

            count.set(+item.quantity);
            comment.set(item.comment);
            change();
        }
    };

    const tip = {
        'Прямоугольник': 'Прямоугольник',
        'Прямоугольник со скоженными углами': 'Прямоугольник со скоженными углами',
        'Овал': 'Овал',
        'Заказ': 'Заказ',
    };

    const color = options.color || {
        'gubka-black.webp': 'Черный',
        'gubka-bej.webp': 'Бежевый',
    }

    const colorAbraziv = options.color || {
        'Черный': 'Черный',
        'Бежевый': 'Бежевый',
    }

    const upak = options.upak || {
        'С печатью': 'С печатью',
        'Прозрачная': 'Прозрачная',
    }

    const fetch = async () => {
        let result = await network.fetch_data('Rilly');

        // SB/22/45
        //750
        let abraziv = result.filter((item) => item.name.toLowerCase().includes('абразив'));
        let porolon = result.filter((item) => item.name.toLowerCase().includes('ппу'))
        let porolon_data = porolon.reduce((acc, item) => {
            const [marka, plotnost, tolsh] = item.ind4.split('/')

            acc.marka.push(marka)
            acc.plotnost.push(plotnost)
            acc.tolsh.push(tolsh)

            return acc
        }, {marka: [], plotnost: [], tolsh: []});

        let output = {
            abraziv: {
                list: abraziv,
                plotnost: [...new Set(abraziv.map((item) => item.ind4))],
                cvet: [...new Set(abraziv.map((item) => item.ind2))],
            },
            porolon: {
                list: porolon,
                cvet: [...new Set(porolon.map((item) => item.ind2))],
                marka: [...new Set(porolon_data.marka)],
                plotnost: [...new Set(porolon_data.plotnost)],
                tolsh: [...new Set(porolon_data.tolsh)],
            },
            result,
        }

        return output;
    }

    let dlina = 98,
        width = 66,
        tolsh = 30,
        upakovka = 'С печатью',
        transupakovka = 'Коробка 600*400*400',
        kolvoUpak = 10,
        stiker = 'Да',
        ind1 = 'Прямоугольник', //
        ind1Naim = '',
        vListeShtuk = 48,

        // здесь перечень нужных "частей"
        configuration = [
            {type: 'porolon', vidov: 1, tolsh: 25, params: [{color: 'Черный', marka: 'SB', plotnost: '22',  kolvo: 0}]},
            {type: 'abraziv', vidov: 1, tolsh: '', params: [{color: 'Черный', marka: '',   plotnost: '750', kolvo: 0}]},
        ],

        sloyev = 2,

        // другое
        comment = parameter('comment', ''),
        count = parameter('count', 1);

    let fetchData = fetch();
    let title;

    const changeKolvoSloyev = (configuration, newCount) => {
        const currentLength = configuration.length;

        if (newCount > currentLength) {
            // Добавляем недостающие слои
            for (let i = currentLength; i < newCount; i++) {
                configuration.push({
                    type: 'porolon',
                    vidov: 1,
                    params: [{color: '', marka: '', plotnost: '', tolsh: '', kolvo: 0}]
                });
            }
        } else if (newCount < currentLength) {
            // Обрезаем лишние слои
            configuration.splice(newCount);
        }

        return configuration
    }

    const changeKolvoVidov = (element) => {
        let currentLength = element.params.length;
        let targetLength = element.vidov;

        if (targetLength > currentLength) {
            // Добавляем недостающие элементы
            for (let i = currentLength; i < targetLength; i++) {
                element.params.push({...element.params[0]});
            }
        } else if (targetLength < currentLength) {
            // Обрезаем лишние элементы
            element.params.splice(targetLength);
        }

        element.params.map((vid) => vid.kolvo = Math.floor(kolvoUpak / targetLength))

        return element
    };

    // расчёт стоимости
    const change = _.debounce(async () => {
        let data = await fetchData;

        let
            quantity = +$count;
        title = [
            'Губка - ', ind1Naim, ' ', ind1, ' ', kolvoUpak, ' шт.', ' ', width + 'x' + dlina + 'x' + tolsh
        ].join('');

        let result = {
            type: 'Губка',
            name: 'Губка',
            subname: title.replace('Губка - ', '').trim(),
            title: title,
            params: {
                ind1: ind1Naim,
                ind2: configuration
                    .flatMap((group) => group.params.map((param) => ({...param, tolsh: group.tolsh, type: group.type})))
                    .map((el) => `${el.type === 'porolon' ? 'Поролон' : 'Абразив'};${el.color};${el.marka};${el.plotnost};${el.tolsh};${el.kolvo}`)
                    .join('|'),
                ind3: encode(JSON.stringify({
                    dlina,
                    width,
                    tolsh,
                    upakovka,
                    transupakovka,
                    kolvoUpak,
                    stiker,
                    ind1,
                    ind1Naim,
                    vListeShtuk,
                    configuration,
                    sloyev
                })),
                ind4: width,
                ind5: dlina,
            },
            price: {rozn: 0, opt: 0, sebest: 0,},
            quantity,
            materials: {},
            comment: $comment,
            vStrukture: 79
        };

        const list = {w: 1000, h: 2000}
        const by_dlina = Math.floor(list.h / dlina)
        const by_width = Math.floor(list.w / width)

        const buf_dlina = ((by_dlina * dlina) + (by_dlina * 5))
        const kolvoVliste = ind1 === 'Заказ' ?
            vListeShtuk :
            ((buf_dlina + 40) > list.h) ? (by_dlina - 1) * by_width : by_dlina * by_width

        const addMaterial = (item, kolvo = 1) => {
            let price = {rozn: 0, opt: 0, sebest: 0}

            price['rozn'] = fixprecision(kolvo * (1 + item.procentSpisania / 100) * item.price);
            price['opt'] = fixprecision(kolvo * (1 + item.procentSpisania / 100) * item.opt_price);
            price['sebest'] = fixprecision(kolvo * (1 + item.procentSpisania / 100) * item.sebestomost);

            if (result.materials?.[item.name]) {
                result.materials[item.name].count = parseFloat(result.materials[item.name].count) + parseFloat(kolvo)
            } else {
                result.materials[item.name] = {
                    order: +item.poryadok,
                    id: item.idTovar,
                    spis: item.procentSpisania,
                    type: item.edIzmer,
                    oprice: {
                        rozn: (+item.price).toFixed(2),
                        opt: (+item.opt_price).toFixed(2),
                        sebest: (+item.sebestomost).toFixed(2),
                    },
                    price,
                    quantity,
                    count: kolvo
                };
            }
        }

        _.forEach(data.result, function (el) {
            let item = _.cloneDeep(el);
            let name = item.name.toLowerCase();

            let kolvo = 0;

            if (name.includes('клей')) {
                kolvo = (parseFloat(item.ind1.replace(',', '.')) / kolvoVliste * kolvoUpak).toFixed(6);

                if (ind1 === 'Губка для посуды') {
                    kolvo *= 2
                }
            }
            if (name.includes('бопп') && name.includes(upakovka.toLowerCase())) {
                kolvo = parseFloat(item.ind1.replace(',', '.')).toFixed(3);
            }

            if (name.includes('стикер') && upakovka.includes('Прозрачная')) {
                kolvo = parseFloat(1 / kolvoUpak).toFixed(3);
            }

            if ((name.includes('этикет') || name.includes('коробка')) && transupakovka.toLowerCase().includes('коробка')) {
                const v = 600 * 400 * 400
                const ved = dlina * width * tolsh;
                const vup = Math.floor(ved * (kolvoUpak * (1 + parseFloat(item.ind1.replace(',', '.')))));
                const kolvovkorobke = Math.floor(v / vup);

                kolvo = parseFloat(1 / (kolvovkorobke)).toFixed(3);
            }

            if (kolvo) {
                addMaterial(item, kolvo)
            }
        });

        const selectPorolon = (items, target) => {
            const filtered = items.filter((el) => parseInt(el.ind4.split('/')[2]) <= target)

            if (filtered.length) {
                const item = {...filtered.reduce((prev, curr) => +curr.ind4.split('/')[2] > +prev.ind4.split('/')[2] ? curr : prev)};
                const tolsh = parseInt(item.ind4.split('/')[2])

                // правим цену
                if (target - tolsh > 0) {
                    item.price = (item.price / tolsh) * target
                    item.opt_price = (item.opt_price / tolsh) * target
                    item.sebestomost = (item.sebestomost / tolsh) * target
                }

                return {item, kolvo: ((1 / kolvoVliste) * kolvoUpak).toFixed(6)}
            }

            return {item: null, kolvo: 0}
        }

        configuration.forEach((group) => {
            let {type, tolsh, params} = group;

            params.forEach((sloy) => {
                if (type === 'porolon') {
                    let items = data.result
                        .filter((item) => item.name.toLowerCase().includes('ппу'))
                        .filter((item) => item.ind2 === sloy.color && item.ind4.startsWith(`${sloy.marka}/${sloy.plotnost}`))

                    let {item, kolvo} = selectPorolon(items, parseInt(tolsh))

                    if (kolvo) {
                        addMaterial(item, kolvo)
                    }
                }

                if (type === 'abraziv') {
                    let item = data.result
                        .filter((item) => item.name.toLowerCase().includes('абразив'))
                        .find((item) => item.ind2 === sloy.color && item.ind4 === `${sloy.plotnost}`)

                    if (item) {
                        let kolvo = (1 / kolvoVliste * kolvoUpak).toFixed(6)

                        if (kolvo) {
                            addMaterial(item, kolvo)
                        }
                    }
                }
            })
        })

        result.price.rozn = _.sumBy(_.values(_.mapValues(result.materials, (o) => o.price)), 'rozn').toFixed(6);
        result.price.opt = _.sumBy(_.values(_.mapValues(result.materials, (o) => o.price)), 'opt').toFixed(6);
        result.price.sebest = _.sumBy(_.values(_.mapValues(result.materials, (o) => o.price)), 'sebest').toFixed(6);
        result.price._precision = 1000;

        dispatch('item', result);
    }, 250);

    change();
</script>

{#await fetchData}
    <div class="card-body">
        <div class="text-center">
            <p>Загрузка..</p>
        </div>
    </div>
{:then data}
    <div class="card-body" on:keyup={change} on:paste={change} on:change={change}>
        <div class="row">
            <div class="col-12 col-md-5">
                <div class="form-group boxed">
                    <img
                        alt=""
                        style="height: 250px; width: 100%; object-fit: contain; object-position: center center;"
                        class="img-fluid px-3"
                        src={`/img/rilly/${ind1 === 'Рельеф' ? 'relef.jpg' : ind1 === 'Овал' ? 'gubka-bej.webp' : 'pasuda.jpg'}`}
                    />
                </div>
            </div>

            <div class="col-12 col-md-7">
                <div class="row">
                    <div class="col-12">
                        <div class="form-group boxed">
                            <div class="input-wrapper">
                                <label class="form-label">Наименование</label>
                                <input type="text" class="form-control" bind:value={ind1Naim}>
                            </div>
                        </div>
                    </div>

                    <div class="col-6">
                        <div class="form-group boxed">
                            <div class="input-wrapper">
                                <label class="form-label">Штук в упаковке</label>
                                <input type="number" class="form-control" step="1" min="1" bind:value={kolvoUpak}>
                            </div>
                        </div>
                    </div>

                    <div class="col-6">
                        <div class="form-group boxed">
                            <div class="input-wrapper">
                                <label class="form-label">Тип</label>
                                <select class="form-control form-select" bind:value={ind1}>
                                    {#each Object.entries(tip) as [value, name]}
                                        <option value="{value}">{name}</option>
                                    {/each}
                                </select>
                            </div>
                        </div>
                    </div>

                    {#if ind1 === 'Заказ'}
                        <div class="offset-6 col-6">
                            <div class="form-group boxed">
                                <div class="input-wrapper">
                                    <label class="form-label">В листе штук</label>
                                    <input type="number" class="form-control" bind:value={vListeShtuk}>
                                </div>
                            </div>
                        </div>
                    {/if}
                </div>

                <div class="row">
                    <div class="col-4">
                        <div class="form-group boxed">
                            <div class="input-wrapper">
                                <label class="form-label">Ширина, мм</label>
                                <input type="number" class="form-control" step="5" min="25" max="100" bind:value={width} use:validate_int={width}>
                            </div>
                        </div>
                    </div>
                    <div class="col-4">
                        <div class="form-group boxed">
                            <div class="input-wrapper">
                                <label class="form-label">Длина, мм</label>
                                <input type="number" class="form-control" step="5" min="25" max="100" bind:value={dlina} use:validate_int={dlina}>
                            </div>
                        </div>
                    </div>
                    <div class="col-4">
                        <div class="form-group boxed">
                            <div class="input-wrapper">
                                <label class="form-label">Толщина, мм</label>
                                <input type="number" class="form-control" step="1" min="25" max="100" bind:value={tolsh} use:validate_int={tolsh}>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-6">
                        <div class="form-group boxed">
                            <div class="input-wrapper">
                                <label class="form-label">Кол-во слоев</label>
                                <select class="form-control form-select" bind:value={sloyev} on:change={({target}) => configuration = changeKolvoSloyev(configuration, target.value)}>
                                    {#each {length: 3} as _, i}
                                        <option value={i+1}>{i+1}</option>
                                    {/each}
                                </select>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-12">
                <div class="row gap-1">
                    {#if configuration.length}
                        {@const sloyevSum = configuration.map((sloy) => sloy.type === 'abraziv' ? 5 : sloy.tolsh).reduce((sum, tolsh) => sum + tolsh, 0)}

                        {#each configuration as sloy, s}
                            <div class="col-12">
                                <strong class="small">Слой {s + 1}</strong><br>

                                <div class="border rounded p-1 position-relative">
                                    <div class="row">
                                        <div class="col-6">
                                            <label class="form-label">Тип</label>
                                            <select class="form-control form-select border-dark" bind:value={sloy.type}>
                                                <option disabled selected value="">Тип</option>
                                                <option value="porolon">Поролон</option>
                                                <option value="abraziv">Абразив</option>
                                            </select>
                                        </div>

                                        {#if sloy.type === 'porolon'}
                                            <div class="col-4">
                                                <label class="form-label">Толщина</label>
                                                <input type="number" class="form-control" min="5" max={tolsh} bind:value={sloy.tolsh} use:validate_int={sloy.tolsh}>
                                            </div>

                                            <div class="col-2">
                                                <label class="form-label">Кол-во видов</label>
                                                <select class="form-control form-select" bind:value={sloy.vidov} on:change={() => sloy = changeKolvoVidov(sloy)}>
                                                    {#each {length: kolvoUpak} as _, i}
                                                        <option value={i+1}>{i+1}</option>
                                                    {/each}
                                                </select>
                                            </div>

                                            <div class="col-12 mt-1">
                                                <TabContent>
                                                    {#each sloy.params as vid, v}
                                                        {@const plotnost_list = Array.from(new Set(
                                                            data.porolon.list
                                                                .filter(item => item.ind4.includes(vid.marka))
                                                                .map(item => item.ind4.split('/')[1])
                                                        ))}
                                                        {@const color_list = Array.from(new Set(
                                                            data.porolon.list
                                                                .filter(item => item.ind4.includes(vid.marka) && item.ind4.includes(vid.plotnost))
                                                                .map(item => item.ind2)
                                                        ))}
                                                        {@const check_item = data.result
                                                            .filter((item) => item.name.toLowerCase().includes('ппу'))
                                                            .find((item) => {
                                                                const [bmarka, bplotnost, btolsh] = item.ind4.split('/')

                                                                return (
                                                                    vid.color === item.ind2 &&
                                                                    vid.marka === bmarka &&
                                                                    vid.plotnost === bplotnost &&
                                                                    sloy.tolsh >= btolsh
                                                                )
                                                            })
                                                        }

                                                        <TabPane class="border border-top-0 p-1" tabId={`vid-${v}`} tab={`Вид ${v + 1}`} active={v === 0}>
                                                            <div class="row">
                                                                <div class="col-3">
                                                                    <label class="form-label">Марка</label>
                                                                    <select class="form-control form-select" bind:value={vid.marka}>
                                                                        <option disabled selected value="">Марка</option>
                                                                        {#each data.porolon.marka as value}
                                                                            <option value="{value}">{value}</option>
                                                                        {/each}
                                                                    </select>
                                                                </div>

                                                                <div class="col-3">
                                                                    <label class="form-label">Плотность</label>
                                                                    <select class="form-control form-select" bind:value={vid.plotnost}>
                                                                        <option disabled selected value="">Плотность</option>
                                                                        {#each plotnost_list as value}
                                                                            <option value="{value}">{value}</option>
                                                                        {/each}
                                                                    </select>
                                                                </div>

                                                                <div class="col-3">
                                                                    <label class="form-label">Цвет</label>
                                                                    <select class="form-control form-select" bind:value={vid.color}>
                                                                        <option disabled selected value="">Цвет</option>
                                                                        {#each color_list as value}
                                                                            <option value="{value}">{value}</option>
                                                                        {/each}
                                                                    </select>
                                                                </div>

                                                                {#if sloy.vidov > 1}
                                                                    {@const check = sloy.params.reduce((sum, el) => sum + el.kolvo, 0) === kolvoUpak}

                                                                    <div class="col-3">
                                                                        <label class="form-label">Количество</label>
                                                                        <input type="number" class="form-control border-dark" min="1" max={kolvoUpak} bind:value={vid.kolvo} use:validate_int={vid.kolvo}>
                                                                    </div>

                                                                    {#if !check}
                                                                        <div class="col-12 mt-1">
                                                                            <div class="alert alert-outline-danger text-center" data-error="true">
                                                                                Проверьте количество
                                                                            </div>
                                                                        </div>
                                                                    {/if}
                                                                {/if}

                                                                {#if !check_item}
                                                                    <div class="col-12 mt-1">
                                                                        <div class="alert alert-outline-danger text-center" data-error="true">
                                                                            Поролон с выбранными параметрами (марка, плотность, цвет и толщина) не найден
                                                                        </div>
                                                                    </div>
                                                                {/if}
                                                            </div>
                                                        </TabPane>
                                                    {/each}
                                                </TabContent>
                                            </div>
                                        {/if}

                                        {#if sloy.type === 'abraziv'}
                                            {@const color_list = Array.from(new Set(
                                                data.abraziv.list
                                                    .filter(item => item.ind4.includes(sloy.params[0].plotnost))
                                                    .map(item => item.ind2)
                                            ))}
                                            {@const check_item = data.result
                                                .filter((item) => item.name.toLowerCase().includes('абразив'))
                                                .find((item) => item.ind2 === sloy.params[0].color && item.ind4 === `${sloy.params[0].plotnost}`)
                                            }

                                            <div class="col-4">
                                                <label class="form-label">Толщина</label>
                                                <div class="input-group">
                                                    <span class="input-group-text" style="border-radius: .375rem 0 0 .375rem; font-size: 12px">Всегда</span>
                                                    <input type="number" class="form-control" value="5" readonly>
                                                </div>
                                            </div>

                                            <div class="col-12 mt-1">
                                                <div class="row ">
                                                    <div class="col-6">
                                                        <div class="input-wrapper">
                                                            <label class="form-label">Плотность</label>
                                                            <select class="form-control form-select" bind:value={sloy.params[0].plotnost}>
                                                                <option disabled selected value="">Плотность</option>
                                                                {#each data.abraziv.plotnost as value}
                                                                    <option value="{value}">{value}</option>
                                                                {/each}
                                                            </select>
                                                        </div>
                                                    </div>

                                                    <div class="col-6">
                                                        <div class="input-wrapper">
                                                            <label class="form-label">Цвет</label>
                                                            <select class="form-control form-select" bind:value={sloy.params[0].color}>
                                                                <option disabled selected value="">Цвет</option>
                                                                {#each color_list as value}
                                                                    <option value="{value}">{value}</option>
                                                                {/each}
                                                            </select>
                                                        </div>
                                                    </div>

                                                    {#if !check_item}
                                                        <div class="col-12 mt-1">
                                                            <div class="alert alert-outline-danger text-center" data-error="true">
                                                                Такого абразива нет
                                                            </div>
                                                        </div>
                                                    {/if}
                                                </div>
                                            </div>
                                        {/if}
                                    </div>
                                </div>
                            </div>
                        {/each}

                        {#if sloyevSum !== tolsh}
                            <div class="col-12">
                                <div class="alert alert-outline-danger text-center" data-error="true">
                                    <b>Ошибка</b>: скорректируйте толщины слоев
                                </div>
                            </div>
                        {/if}
                    {/if}
                </div>
            </div>

            <div class="row">
                <div class="col-4">
                    <div class="form-group boxed">
                        <div class="input-wrapper">
                            <label class="form-label">Упаковка</label>
                            <select class="form-control form-select" bind:value={upakovka}>
                                {#each Object.entries(upak) as [value, name]}
                                    <option value="{value}">{name}</option>
                                {/each}
                            </select>
                        </div>
                    </div>
                </div>

                {#if upakovka === 'Прозрачная'}
                    <div class="col-4">
                        <div class="form-group boxed">
                            <div class="input-wrapper">
                                <label class="form-label">Cтикер</label>
                                <select class="form-control form-select" bind:value={stiker} on:change={() => {change()}}>
                                    <option value="Да">Да</option>
                                    <option value="Нет">Нет</option>
                                </select>
                            </div>
                        </div>
                    </div>
                {/if}

                <div class="col-4">
                    <div class="form-group boxed">
                        <div class="input-wrapper">
                            <label class="form-label">Трансп. упаковка</label>
                            <select class="form-control form-select" bind:value={transupakovka}>
                                <option value="Коробка 600*400*400">Коробка 600*400*400</option>
                                <option value="Пакет">Пакет</option>
                            </select>
                        </div>
                    </div>
                </div>

                <div class="col-4">
                    <div class="form-group boxed">
                        <div class="input-wrapper">
                            <label class="form-label">Количество</label>
                            <input type="number" class="form-control" min="1" bind:value={$count} use:validate_int={count}>
                        </div>
                    </div>
                </div>

                <div class="col-12">
                    <div class="form-group boxed">
                        <div class="input-wrapper">
                            <div class="input-wrapper">
                                <label class="form-label">Примечание</label>
                                <textarea class="form-control" bind:value={$comment}></textarea>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
{/await}
